import { Injectable } from '@angular/core';
import {BehaviorSubject, ReplaySubject, Subject} from "rxjs";
import {CookieService} from "../coockieService/coockie.service";
import {CesiumAdapterService} from "@src/app/services/cesiumAdapter21/cesium-adapter.service";

interface modalOptions{
  backdrop?: string | boolean,
  keyboard?: boolean,
  modalId?: string,
  modalConfig?: any
}

const defaultOptions:modalOptions = {
  backdrop: true,
  keyboard: true
};

@Injectable({
  providedIn: 'root'
})

export class EsBsModalService {

  private _currentModal = new BehaviorSubject<string>(null);
  private _modalUpdated = new Subject<string>();
  private _modalFiresEvent$ = new Subject<any>();
  private _currentModalMsg$ = new Subject<any>();
  private _modalConfig = null;

  set currentModalMsg$(val:string){
    this._currentModalMsg$.next(val)
  }

  get onModalMsgUpdated$(){
    return this._currentModalMsg$.asObservable();
  }

  get onModalFiresEvent$(){
    return this._modalFiresEvent$.asObservable();
  }

  set modalEventFire$(val: {[key: string]: any}){
    this._modalFiresEvent$.next(val);
  }

  get modalUpdated(){
    return this._modalUpdated.asObservable();
  }

  get currentModalUpdate(){
    return this._currentModal.asObservable();
  }
  get currentModal(){
    return this._currentModal.getValue();
  }
  set currentModal(elmClass:string){
    this.removeOldListeners();
    this._currentModal.next(elmClass);
    this.initListeners();
  }

  constructor(private adapter: CesiumAdapterService) {
    this.adapter.onOpenAlert$.subscribe((alertString)=>{
      let element = document.querySelector(alertString);
      if (element){
        element.classList.remove('fade');
      }
    })
  }

  private initListeners(){
    let self = this;
    jQuery(this.currentModal).on('hidden.bs.modal', function (e) {
      self._modalUpdated.next('closed');
      self._currentModal.next(null);
    });
    jQuery(this.currentModal).on('shown.bs.modal', function (e) {
      self._modalUpdated.next('opened');
    })
  }

  private removeOldListeners(){
    jQuery(this.currentModal).off('hidden.bs.modal');
    jQuery(this.currentModal).off('shown.bs.modal');
  }

  openModal(options?:modalOptions){
    if (options && options.hasOwnProperty('modalId')){
      this.currentModal = options.modalId;
    }

    if (options && options.hasOwnProperty('modalConfig')){
      this._modalConfig = options.modalConfig;
    }
    if (!options){
      options = defaultOptions;
    }
    if (!this.currentModal){
      console.error('modal to open doesn\'t set');
      return;
    }
    let backdrop: string | boolean = 'static';
    if (options.backdrop) { backdrop = options.backdrop; }
    if (options.backdrop === false) { backdrop = false;}
    jQuery(this.currentModal).modal({backdrop: backdrop, keyboard: options.keyboard || true, show: true});
    jQuery(this.currentModal).data('bs.modal')._config.backdrop = backdrop;
    jQuery(this.currentModal).data('bs.modal')._config.keyboard = options.keyboard || false;
  }

  closeModal(cb?, modalId?){
    if (modalId && this.currentModal != modalId) {
      return;
    }
    if (!this.currentModal){
      return;
    }
    let $modal = jQuery(this.currentModal);
    if (cb){
      $modal.on('hidden.bs.modal', ()=>{
        cb();
        $modal.off('hidden.bs.modal');
      })
    }
    $modal.modal('hide');
  }


  getCurrentConfig() {
    return this._modalConfig;
  }
}
